import {
    Alert,
    AppBar,
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    List,
    ListItemButton,
    ListItemText,
    ListSubheader,
    MenuItem,
    OutlinedInput,
    Rating,
    Select,
    Stack,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material'
import { GridCloseIcon } from '@mui/x-data-grid'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import {
    setEditTrainingModal,
    setEditTrainingsModal,
    setEditedExamQualifyData,
    setTrainingToEdit
} from '../../store/reducers/modal.reducer'
import { t } from 'i18next'
import { TExam } from '../../shared/types/exam.type'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import { useExam } from '../../hooks/useExam'
import { TQualifyChoice } from '../../shared/types/qualifyChoices.type'
import { toast } from 'react-toastify'
import { get, sortBy, toNumber, uniqBy } from 'lodash'
import { TShoeing } from '../../shared/types/shoeing.type'
import { Ttrack, trackSurface } from '../../shared/types/tracks.type'
import { TtrackCondition } from '../../shared/types/trackCondition.type'
import { TTrainingType } from '../../shared/types/training.type'
import { TRider } from '../../shared/types/rider.type'
import TrainingEditSkeleton from '../exams/loader/TrainingEditSkeleton'
import { Create, Delete, ListAlt } from '@mui/icons-material'
import { useQueryClient } from 'react-query'
import { LoadingButton } from '@mui/lab'
import DeleteModal from './DeleteModal'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../pages/routes'
import { THorse } from '../../shared/types/horse.type'
import { Icon } from '@iconify/react'
import { formatDate, getCorrectDateFormat } from '../../shared/utils/DateUtils'
import { useAuth } from '../../hooks/useAuth'
import { TUser } from '../../shared/types/user.type'
import { transformTraining } from '../../transformer/EditTrainingPayload'
import NotFound from '../global/NotFound'
import Lottie from 'lottie-react'
import animationEmpty from '../../lottie/animationEmpty.json'
import { toCelsius } from '../../shared/utils/conversion'

function EditTrainingModal() {
    const open = useSelector<RootState>(state => state.modals.editTrainingModal) as boolean
    const item = useSelector<RootState>(state => state.modals.trainingToEdit) as TExam | undefined
    const [data, setData] = useState<any>()
    const [horseShoeing, setHorseShoeing] = useState<TShoeing[]>([])
    const [trackNames, setTrackNames] = useState<Ttrack[]>([])
    const [trackConditions, setTrackConditions] = useState<TtrackCondition[]>([])
    const [trackSurfaces, setTrackSurfaces] = useState<trackSurface[]>([])
    const [trainingTypes, setTrainingTypes] = useState<TTrainingType[]>([])
    const [riders, setRiders] = useState<TRider[]>([])
    const [horses, setHorses] = useState<THorse[]>([])
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openConfirmLeaveDialog, setConfirmLeaveDialog] = useState(false)

    //booleans for wheater show select or text field
    const [useCustomTrainingType, setCustomTrainingType] = useState(false)
    const [useCustomTrackName, setCustomTrackName] = useState(false)
    const [useCustomTrackCondition, setCustomTrackCondition] = useState(false)
    const [useCustomRider, setCustomRider] = useState(false)
    const [useCustomShoeing, setCustomShoeing] = useState(false)
    const auth = useSelector<RootState>(state => state.user?.user) as TUser | undefined


    const [isUnothorized, setIsUnothorized] = useState(false)

    const {
        getChoices,
        isItemToEditLoading,
        editTrainingMutation,
        isItemEditing,
        deleteExam,
        getEqmTitle
    } = useExam(false, get(auth, '@id'))
    const blockedFromLeaving = useSelector<RootState>(state => state.modals.blockLeaveEditTrainingModal) as boolean
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    useEffect(() => {
        if (item?.training?.id && open) {

            getChoices(item.training.id)
                .then(data => {

                    setValue('comment', get(data, 'current_comment', ''))
                    setValue('horse_shoeing', get(data, 'current_horse_shoeing.@id', ''))
                    setValue('intensity', get(data, 'current_intensity', 0))
                    let track_name = get(data, 'current_track_name', undefined) ?? get(data, 'current_track_name_automatic')
                    setValue('track_name', track_name?.["@id"])
                    setValue('trainer_horse', get(data, 'current_trainer_horse["@id"]', ''))
                    setValue('track_condition', get(data, 'current_track_condition["@id"]', ''))

                    let training_type = get(data, 'current_training_type', undefined) ?? get(data, 'current_training_type_automatic')
                    setValue('training_type', training_type?.["@id"])

                    let track_surface = get(data, 'current_track_surface', undefined) ?? get(data, 'current_track_surface_automatic')
                    setValue('track_surface', track_surface?.["@id"])
                    setValue('rider', get(data, 'current_rider["@id"]', ''))
                    setValue('use_finish_line', get(data, 'current_use_finish_line', false))
                    setValue('is_reference', item.training.is_reference ?? false)
                    setValue('horse_shoeing', get(data, 'current_horse_shoeing["@id"]', ""))
                    setData(data)
                    setHorseShoeing(get(data, 'horse_shoeings', []))

                    let track_names = get(data, 'track_names', []) as Ttrack[]
                    setTrackNames(uniqBy([...track_names, ...(track_name ? [track_name] : [])], e => e?.['@id']))
                    setTrackConditions(get(data, 'track_conditions', []))

                    let track_surfaces = get(data, 'track_surfaces', [])

                    let track_names_surfaces = trackNames.map(e => e?.track_surface).filter(e => e) as Ttrack[]


                    setTrackSurfaces(uniqBy([...track_surfaces, ...track_names_surfaces, ...(track_surface ? [track_surface] : [])], e => e?.['@id']))

                    let training_types = get(data, 'training_types', [])
                    setTrainingTypes(uniqBy([...training_types, ...(training_type ? [training_type] : [])], e => e?.['@id']))
                    setRiders(get(data, 'riders', []))
                    setHorses(get(data, 'trainer_horses', []))


                    //Polo user fields
                    if (auth?.type === 'POLO') {
                        setValue('pitch_humidity', data?.pitch_humidity)
                        setValue('pitch_temperature', data?.pitch_temperature)

                    }
                }).catch(err => {
                    console.log({ err })
                    if (err) {
                        if (err?.status === 403) {
                            setIsUnothorized(true)
                        }
                        toast(t('error:generic'), { type: 'error' })

                    }

                })
        }
    }, [item?.training?.id, open, auth?.type])

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        getValues,
        watch,
        control,
        formState: { errors, touchedFields },
    } = useForm<TQualifyChoice>({})

    const watchTrack = watch('track_name')

    const showFinishLine = useMemo((): boolean => {
        if (!watchTrack) return false
        let findTrack = trackNames.find(e => get(e, '@id') === watchTrack)


        if (findTrack) {
            let finishLine = findTrack?.finish_line


            return finishLine ? true : false
        } else {

            return false
        }

    }, [watchTrack])


    const onSubmit: SubmitHandler<TQualifyChoice> = (data) => {
        let id = item?.training?.id
        if (!id) {
            toast(t('error:generic'), { type: 'error' })
            return
        }

        //check if new value are created we remove the selected one from the list
        data.new_rider && delete data.rider
        data.new_horse_shoeing && delete data.horse_shoeing
        data.new_track_name && delete data.track_name
        data.new_training_type && delete data.training_type
        data.new_track_condition && delete data.track_condition

        if (auth?.type !== "POLO") {
            delete data?.pitch_humidity
            delete data?.pitch_temperature
        } else {
            if (data?.pitch_temperature) {
                data.pitch_temperature = toCelsius(data.pitch_temperature, auth?.temperature_unit === 'celsius' ? "C" : 'F')
            }
        }


        editTrainingMutation.mutateAsync({ id, data: transformTraining(data) as TQualifyChoice, enablePostProcess: true })
            .then(result => {
                toast(t('rights:success'), { type: 'success' })
                queryClient.refetchQueries(['exam', toNumber(id)])
                handleClose()
                reset()
                setCustomTrainingType(false)
                setCustomTrackName(false)
                setCustomTrackCondition(false)
                setCustomRider(false)
                setCustomShoeing(false)
                dispatch(setTrainingToEdit(null))
                dispatch(setEditTrainingsModal(true))
                dispatch(setEditedExamQualifyData({
                    horse_shoeings: data.horse_shoeing,
                    riders: data.rider,
                    track_conditions: data.track_condition,
                    track_names: data.track_name,
                    track_surfaces: data.track_surface,
                    training_types: data.training_type,
                }))
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
            })


    }
    const handleClose = () => {
        setIsUnothorized(false)
        if (blockedFromLeaving) {
            setConfirmLeaveDialog(true)
            return
        }
        dispatch(setEditTrainingModal(false))
    }
    const deleteTraining = () => {

        if (item?.training.id) {
            deleteExam.mutateAsync(item.training.id)
                .then(result => {
                    toast(t('rights:success'), { type: 'success' })
                    handleClose()
                    queryClient.refetchQueries(['exams'])
                    window.location.pathname = routes.DASHBOARD_ROUTES.TRAININGS;
                }).catch(err => {
                    toast(t('error:generic'), { type: 'error' })

                })
        }

    }

    const getExamDate = () => {
        let userDateFormat = auth?.default_date_format ? getCorrectDateFormat(auth?.default_date_format) + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss'
        let date = formatDate(item?.training?.creation_date ?? "", userDateFormat)
        return date
    }

    const isTrainingDeletionDisabled = useMemo(() => {
        if (!auth) return false

        const DELETE_CONFIG_KEY = "DISABLE_TRAINING_DELETION"

        const getConfig = auth.configurations.find(conf => conf.key === DELETE_CONFIG_KEY)

        return getConfig ? getConfig.value : false

    }, [auth])


    if (!open) return null


    return (
        <>
            <Dialog
                maxWidth='md'
                open={open}
                onClose={(_, reason) => {
                    // Prevent closing on backdrop click or Escape key
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    handleClose()
                }}

            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>


                        <Typography fontWeight={400} sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {t('editTrainingForm:editTraining')}
                        </Typography>
                        {<IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <GridCloseIcon />
                        </IconButton>}
                    </Toolbar>
                </AppBar>
                {isItemToEditLoading ? <TrainingEditSkeleton></TrainingEditSkeleton> :
                    isUnothorized ?
                        <DialogContent sx={{
                            width: '350px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Lottie style={{ width: '200px', height: '200px' }} animationData={animationEmpty}
                                loop={false}></Lottie>

                            <Typography>{t('error:notfound:heading')}</Typography>
                            <Typography fontSize={'13px'}>{t('error:notfound:subHeading')}</Typography>
                        </DialogContent>
                        :
                        <>
                            <form onSubmit={handleSubmit(onSubmit)}>

                                <DialogContent>
                                    {
                                        blockedFromLeaving &&
                                        <Stack direction={'column'} spacing={1} mb={1}>
                                            <Alert severity='info'>
                                                {t('training:noHorseHint')}
                                            </Alert>
                                            <Typography color={'lightgray'}
                                                variant='body2'>{`${getExamDate()} / ${getEqmTitle(item?.training?.equimetre)}`}</Typography>
                                        </Stack>
                                    }


                                    <Grid container spacing={3}>

                                        <Grid item md={12} sm={12} xs={12}>

                                            <FormControl fullWidth
                                                error={errors?.hasOwnProperty('trainer_horse')}
                                            >

                                                <Autocomplete
                                                    options={sortBy(horses, horse => horse.display_name)}
                                                    defaultValue={horses.find(e => e['@id'] === getValues('trainer_horse'))}
                                                    getOptionLabel={item => item?.display_name ?? ' - '}
                                                    isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                    getOptionKey={item => item['@id']}
                                                    aria-required
                                                    renderInput={(params) => <TextField required {...params}
                                                        label={t('editTrainingForm:changeHorse:label')} />}
                                                    onChange={(e, value) => {
                                                        setValue('trainer_horse', value?.['@id'])
                                                    }}
                                                />

                                            </FormControl>
                                        </Grid>
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth
                                                error={errors?.hasOwnProperty('training_type')}
                                            >
                                                {
                                                    !useCustomTrainingType ?

                                                        <Stack direction={'row'} gap={1}>

                                                            <Autocomplete
                                                                sx={{ flex: 1 }}
                                                                options={sortBy(trainingTypes, type => type.display_name)}
                                                                defaultValue={trainingTypes.find(e => e['@id'] === getValues('training_type'))}
                                                                getOptionLabel={item => item?.display_name ?? ' - '}
                                                                isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                                getOptionKey={item => item['@id']}
                                                                renderInput={(params) => <TextField

                                                                    {...params}
                                                                    label={t(auth?.type === "POLO" ? "activity" : 'editTrainingForm:trainingType:label')} />}
                                                                onChange={(e, value) => {
                                                                    setValue('training_type', value?.['@id'])
                                                                }}
                                                            />
                                                            <Tooltip
                                                                title={t(auth?.type === 'POLO' ? "addActivity" : 'otherTrainingType')}>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCustomTrainingType(true)
                                                                    }}
                                                                    sx={{ mr: 1 }}
                                                                    edge="end"
                                                                >
                                                                    <Icon icon='quill:add'></Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                        :
                                                        <>
                                                            <InputLabel
                                                                id="demo-simple-select-label">{t(auth?.type === 'POLO' ? "addActivity" : 'otherTrainingType')}</InputLabel>

                                                            <OutlinedInput
                                                                {...register('new_training_type', { required: false })}
                                                                endAdornment={
                                                                    <InputAdornment position="start">
                                                                        <Tooltip
                                                                            title={t(auth?.type === "POLO" ? "activity" : 'editTrainingForm:trainingType:label')}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setCustomTrainingType(false)
                                                                                }}
                                                                                edge="end"
                                                                            >
                                                                                <ListAlt></ListAlt>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </InputAdornment>
                                                                }
                                                                label={t(auth?.type === 'POLO' ? "addActivity" : 'otherTrainingType')}
                                                            ></OutlinedInput>
                                                        </>
                                                }

                                            </FormControl>
                                        </Grid>
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>

                                                {
                                                    !useCustomTrackName ?
                                                        <> <Stack direction={'row'} gap={1}>

                                                            <Autocomplete
                                                                sx={{ flex: 1 }}
                                                                options={sortBy(trackNames, track => track.display_name)}
                                                                defaultValue={trackNames.find(e => e['@id'] === getValues('track_name'))}
                                                                getOptionLabel={item => item?.display_name ?? ' - '}
                                                                isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                                getOptionKey={item => item['@id']}
                                                                renderInput={(params) => <TextField
                                                                    {...params}
                                                                    label={t('editTrainingForm:trackName:label')} />}
                                                                onChange={(e, value) => {
                                                                    console.log({ value });

                                                                    if (value?.track_surface) {
                                                                        let current_ts = value.track_surface as trackSurface

                                                                        setValue('track_surface', current_ts['@id'])
                                                                    }

                                                                    setValue('track_name', value?.['@id'])
                                                                }}
                                                            />
                                                            <Tooltip title={t('newTrackName')}>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCustomTrackName(true)
                                                                    }}
                                                                    sx={{ mr: 1 }}
                                                                    edge="end"
                                                                >
                                                                    <Icon icon='quill:add'></Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                            {
                                                                showFinishLine && <Grid item md={12} sm={12} xs={12}>
                                                                    <FormControl>
                                                                        <FormControlLabel label={
                                                                            <Typography color={'gray'} component="legend"
                                                                                variant='body2'>{t('editTrainingForm:useFinishLine')}</Typography>}
                                                                            control={<Checkbox
                                                                                defaultChecked={getValues('use_finish_line')}
                                                                                onChange={e => setValue('use_finish_line', e.target.checked)} />} />
                                                                    </FormControl>
                                                                </Grid>
                                                            }</>
                                                        :
                                                        <>
                                                            <InputLabel
                                                                id="demo-simple-select-label">{t('newTrackName')}</InputLabel>

                                                            <OutlinedInput
                                                                {...register('new_track_name', { required: false })}
                                                                endAdornment={
                                                                    <InputAdornment position="start">
                                                                        <Tooltip title={t('navbar:myTracks')}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setCustomTrackName(false)
                                                                                }}
                                                                                edge="end"
                                                                            >
                                                                                <ListAlt></ListAlt>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </InputAdornment>
                                                                }
                                                                label={t('newTrackName')}
                                                            ></OutlinedInput>
                                                        </>
                                                }

                                            </FormControl>
                                        </Grid>

                                        {/* Track surface */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>
                                                <FormControl fullWidth>
                                                    <Controller
                                                        name="track_surface"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Autocomplete
                                                                {...field}
                                                                options={sortBy(trackSurfaces, (surface) => surface.display_name)}
                                                                value={trackSurfaces.find((e) => e["@id"] === field.value) || null} // Ensure reactivity
                                                                getOptionLabel={(item) => item?.display_name ?? " - "}
                                                                isOptionEqualToValue={(option, value) => option["@id"] === value?.["@id"]}
                                                                getOptionKey={(item) => item["@id"]}
                                                                renderInput={(params) => (
                                                                    <TextField {...params}
                                                                        label={t("editTrainingForm:trackSurface:label")} />
                                                                )}
                                                                onChange={(e, value) => {
                                                                    setValue("track_surface", value?.["@id"], { shouldValidate: false });
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </FormControl>

                                            </FormControl>
                                        </Grid>


                                        {/* Show Pitch info to POLO USERS */}

                                        {
                                            auth?.type === "POLO" && <>
                                                {/* Picth Temparature  */}
                                                <Grid item md={12} sm={12} xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel
                                                            id="demo-simple-select-label">{t('pitchTemp')}</InputLabel>
                                                        <OutlinedInput
                                                            type='number'
                                                            endAdornment={
                                                                <Typography>{auth?.temperature_unit === 'celsius' ? "°C" : "°F"}</Typography>}
                                                            {...register('pitch_temperature', { required: false })}
                                                            label={t('pitchTemp')}></OutlinedInput>
                                                    </FormControl>
                                                </Grid>

                                                {/* Humidity  */}
                                                <Grid item md={12} sm={12} xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel
                                                            id="demo-simple-select-label">{t('eap:table:headers:humidity')}</InputLabel>
                                                        <OutlinedInput
                                                            type='number'
                                                            endAdornment={<Typography>%</Typography>}
                                                            {...register('pitch_humidity', { required: false })}
                                                            label={t('eap:table:headers:humidity')}></OutlinedInput>
                                                    </FormControl>
                                                </Grid>
                                            </>
                                        }


                                        {/* Track condition */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth
                                                error={errors?.hasOwnProperty('track_condition')}

                                            >

                                                {
                                                    !useCustomTrackCondition ?
                                                        <Stack direction={'row'} gap={1}>

                                                            <Autocomplete
                                                                sx={{ flex: 1 }}
                                                                options={sortBy(trackConditions, track => track.display_name)}
                                                                defaultValue={trackConditions.find(e => e['@id'] === getValues('track_condition'))}
                                                                getOptionLabel={item => item?.display_name ?? ' - '}
                                                                isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                                getOptionKey={item => item['@id']}
                                                                renderInput={(params) => <TextField

                                                                    {...params}
                                                                    label={t('editTrainingForm:trackCondition:label')} />}
                                                                onChange={(e, value) => {
                                                                    setValue('track_condition', value?.['@id'])
                                                                }}
                                                            />
                                                            <Tooltip title={t('trackCondition:newTrackCondition')}>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCustomTrackCondition(true)
                                                                    }}
                                                                    sx={{ mr: 1 }}
                                                                    edge="end"
                                                                >
                                                                    <Icon icon='quill:add'></Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                        :
                                                        <>
                                                            <InputLabel
                                                                id="demo-simple-select-label">{t('trackCondition:newTrackCondition')}</InputLabel>
                                                            <OutlinedInput
                                                                {...register('new_track_condition', { required: false })}
                                                                endAdornment={
                                                                    <InputAdornment position="start">
                                                                        <Tooltip title={t('navbar:myTrackConditions')}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setCustomTrackCondition(false)
                                                                                }}
                                                                                edge="end"
                                                                            >
                                                                                <ListAlt></ListAlt>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </InputAdornment>
                                                                }
                                                                label={t('trackCondition:newTrackCondition')}
                                                            ></OutlinedInput>
                                                        </>

                                                }

                                            </FormControl>
                                        </Grid>


                                        {/* Rider */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>
                                                {
                                                    !useCustomRider ?


                                                        <Stack direction={'row'} gap={1}>

                                                            <Autocomplete
                                                                sx={{ flex: 1 }}
                                                                options={sortBy(riders, type => type.display_name)}
                                                                defaultValue={riders.find(e => e['@id'] === getValues('rider'))}
                                                                getOptionLabel={item => item?.display_name ?? ' - '}
                                                                isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                                getOptionKey={item => item['@id']}
                                                                renderInput={(params) => <TextField
                                                                    {...params}
                                                                    label={t('editTrainingForm:riderName:label')} />}
                                                                onChange={(e, value) => {
                                                                    setValue('rider', value?.['@id'])
                                                                }}
                                                            />
                                                            <Tooltip title={t('otherRider')}>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCustomRider(true)
                                                                    }}
                                                                    sx={{ mr: 1 }}
                                                                    edge="end"
                                                                >
                                                                    <Icon icon='quill:add'></Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                        :
                                                        <>
                                                            <InputLabel
                                                                id="demo-simple-select-label">{t('otherRider')}</InputLabel>
                                                            <OutlinedInput
                                                                {...register('new_rider', { required: false })}
                                                                endAdornment={
                                                                    <InputAdornment position="start">
                                                                        <Tooltip title={t('navbar:myRiders')}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setCustomRider(false)
                                                                                }}
                                                                                edge="end"
                                                                            >
                                                                                <ListAlt></ListAlt>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </InputAdornment>
                                                                }
                                                                label={t('otherRider')}
                                                            ></OutlinedInput>
                                                        </>
                                                }

                                            </FormControl>
                                        </Grid>
                                        {/* Ferrure */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth
                                                error={errors?.hasOwnProperty('horse_shoeing')}
                                            >
                                                {
                                                    !useCustomShoeing ?
                                                        <Stack direction={'row'} gap={1}>

                                                            <Autocomplete
                                                                sx={{ flex: 1 }}
                                                                options={sortBy(horseShoeing, shoe => shoe.display_name)}
                                                                defaultValue={horseShoeing.find(e => e['@id'] === getValues('horse_shoeing'))}
                                                                getOptionLabel={item => item?.display_name ?? ' - '}
                                                                isOptionEqualToValue={(option, value) => option['@id'] === value?.['@id']}
                                                                getOptionKey={item => item['@id']}
                                                                renderInput={(params) => <TextField

                                                                    {...params}
                                                                    label={t('editTrainingForm:horseShoeing:label')} />}
                                                                onChange={(e, value) => {
                                                                    setValue('horse_shoeing', value?.['@id'])
                                                                }}
                                                            />
                                                            <Tooltip title={t('otherHorseShoeing')}>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCustomShoeing(true)
                                                                    }}
                                                                    sx={{ mr: 1 }}
                                                                    edge="end"
                                                                >
                                                                    <Icon icon='quill:add'></Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack> :
                                                        <>
                                                            <InputLabel
                                                                id="demo-simple-select-label">{t('otherHorseShoeing')}</InputLabel>
                                                            <OutlinedInput
                                                                {...register('new_horse_shoeing', { required: false })}
                                                                endAdornment={
                                                                    <InputAdornment position="start">
                                                                        <Tooltip title={t('navbar:myShoeing')}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setCustomShoeing(false)
                                                                                }}
                                                                                edge="end"
                                                                            >
                                                                                <ListAlt></ListAlt>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </InputAdornment>
                                                                }
                                                                label={t('otherHorseShoeing')}
                                                            ></OutlinedInput>
                                                        </>

                                                }

                                            </FormControl>
                                        </Grid>
                                        {/* Rating */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <Typography color={'gray'} component="legend"
                                                variant='body2'>{t('editTrainingForm:intensity:label')}</Typography>
                                            <Rating name="intensity" defaultValue={getValues('intensity')} size='large'
                                                onChange={(_, value) => setValue('intensity', value ?? 0)} />
                                        </Grid>

                                        {/* Comment */}
                                        <Grid item md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    rows={2}
                                                    {...register('comment', { required: false })}
                                                    multiline label={t('editTrainingForm:comment:label')}></TextField>
                                            </FormControl>
                                        </Grid>

                                        <Grid item md={12} sm={12} xs={12}>
                                            <Controller
                                                control={control}
                                                name='is_reference'
                                                defaultValue={false}
                                                render={({ field: { onChange, value } }) => (
                                                    <Tooltip title={t('training:markAsReferenceHint')} arrow
                                                        placement='right'>
                                                        <FormControlLabel
                                                            label={t('training:markAsReference')}
                                                            control={
                                                                <Checkbox checked={value} onChange={onChange} />
                                                            }
                                                        />
                                                    </Tooltip>
                                                )}
                                            />
                                        </Grid>


                                    </Grid>
                                    <DeleteModal
                                        open={openDeleteModal}
                                        handleClose={() => setOpenDeleteModal(false)}
                                        isDeleting={deleteExam.isLoading}
                                        title='deleteModal:title'
                                        subtitle='deleteModal:body'
                                        onDelete={deleteTraining}
                                    ></DeleteModal>
                                </DialogContent>
                                <DialogActions sx={{ borderTop: '1px solid #808080' }}>
                                    <Box display={'flex'} justifyContent={'end'} alignItems={'center'} gap={2}>
                                        {
                                            !isTrainingDeletionDisabled && <LoadingButton variant='outlined'
                                                disabled={isItemToEditLoading || isUnothorized}
                                                onClick={() => setOpenDeleteModal(true)}
                                                loading={isItemEditing || deleteExam.isLoading}
                                                startIcon={<Delete></Delete>}
                                                color='error'>{t('deleteModal:title')}</LoadingButton>
                                        }

                                        <LoadingButton variant='contained'
                                            disabled={isItemToEditLoading || isUnothorized}
                                            loading={isItemEditing || deleteExam.isLoading}
                                            type='submit'>{t('button:save')}</LoadingButton>

                                    </Box>
                                </DialogActions>
                            </form>

                        </>
                }

                {/* Leave Page Dialog on No horse found */}
                <Dialog
                    open={openConfirmLeaveDialog}
                    onClose={() => {
                        setConfirmLeaveDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('leave:title')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {t('training:noHorseHint')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setConfirmLeaveDialog(false)
                        }}>{t('alert.cancel')}</Button>
                        <Button color='error' variant='contained' onClick={() => {
                            window.location.href = window.location.origin
                            dispatch(setEditTrainingModal(false))
                        }} autoFocus>
                            {t('leave:confirmButton')}
                        </Button>
                    </DialogActions>
                </Dialog>


            </Dialog>
        </>
    )
}

export default EditTrainingModal